export default "__VITE_PUBLIC_ASSET__295e5e2d__"